import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactRouterLink from 'react-router-dom/NavLink';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './Button.css';

class Button extends Component {

  static propTypes = {
    isSubmit: PropTypes.bool,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    activeBackgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    activeTextColor: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    linkHref: PropTypes.string,
    confirmationTitle: PropTypes.string,
    confirmationText: PropTypes.string,
    confirmationAcceptText: PropTypes.string.isRequired,
    confirmationRejectText: PropTypes.string,
    disabled: PropTypes.bool,
    download: PropTypes.string,

    onClick: PropTypes.func,
    onConfirmationFail: PropTypes.func,
  }

  static defaultProps = {
    isSubmit: false,
    disabled: false,
    className: '',
    backgroundColor: '#E96224',
    borderColor: 'transparent',
    textColor: '#ffffff',
    size: 'md',
    confirmationTitle: 'Are you sure?',
    confirmationAcceptText: 'Confirm',
    onClick: () => {},
    onConfirmationFail: () => {},
  }

  state = {
    showModal: false
  }

  _toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  handleConfirmClick(e){
    this.setState({showModal:false});
    this.props.onClick(e);
  }rop

  handleCancelClick(){
    this.setState({showModal:false});
  }

  render() {
    const {
      isSubmit,
      className,
      size,
      disabled,
      linkHref,
      backgroundColor,
      borderColor,
      textColor,
      confirmationTitle,
      confirmationText,
      confirmationAcceptText,
      confirmationRejectText,
      onClick,
      download
    } = this.props;
    var btnSize = `btn-${size}`;
    var disabledClassName = (disabled) ? 'disabled' : '';

    if(isSubmit){
      return (
        <input
          className={`btn btn-primary ${btnSize} ${className} AdjoyButton-routerLink ${disabledClassName}`}
          type="submit"
          disabled={disabled}
          style={{backgroundColor: backgroundColor, color: textColor, borderColor: borderColor}}
          value={this.props.children}
        />
      )
    }
    if(download){
      return (
        <a
          className={`btn btn-primary ${btnSize} ${className} AdjoyButton-routerLink ${disabledClassName}`}
          href={download}
          download
          style={{backgroundColor: backgroundColor, color: textColor, borderColor: borderColor}}
        >
          {this.props.children}
        </a>
      )
    }

    // Link Button - uses React Router Link Component
    if (linkHref && linkHref.length > 0) {
      return (
        <ReactRouterLink
          className={`btn btn-primary ${btnSize} ${className} AdjoyButton-routerLink ${disabledClassName}`}
          to={linkHref}
          style={{backgroundColor: backgroundColor, color: textColor, borderColor: borderColor}}
          onClick={onClick}
        >
          {this.props.children}
        </ReactRouterLink>
      );
    }

    // Button trigger confirmation modal
    if (confirmationText && confirmationText.length > 0) {
      return (
        <span>
          <button
            type='button'
            className={`btn btn-primary ${btnSize} ${className} AdjoyButton-routerLink ${disabledClassName}`}
            style={{backgroundColor: backgroundColor, color: textColor, borderColor: borderColor}}
            disabled={disabled}
            onClick={() => this._toggleModal()}
          >
            {this.props.children}
          </button>
          <Modal isOpen={this.state.showModal} toggle={() => this._toggleModal()}>
            <ModalHeader toggle={() => this._toggleModal()}>{confirmationTitle}</ModalHeader>
            <ModalBody>
              {confirmationText}
            </ModalBody>
            <ModalFooter>
              <button
                type='button'
                className='btn btn-primary'
                onClick={(e) => this.handleConfirmClick(e)}
              >
                {confirmationAcceptText}
              </button>
              {confirmationRejectText && (
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={() => this.handleCancelClick()}
                >
                  {confirmationRejectText}
                </button>
              )}
            </ModalFooter>
          </Modal>
        </span>
      );
    }

    // Default, no React Router Button
    return (
      <button
        type='button'
        className={`btn btn-primary ${btnSize} AdjoyButton-routerLink ${disabledClassName} ${className}`}
        style={{backgroundColor: backgroundColor, color: textColor, borderColor: borderColor}}
        disabled={disabled}
        onClick={onClick}
      >
        {this.props.children}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/shared/components/Button/Button.js